
import { inject } from '@angular/core';
import { HttpRequest, HttpEvent, HttpHandlerFn, HttpInterceptorFn } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, } from 'rxjs/operators'
import { LoadingService } from '../services/loading.service';

/**
 * A HTTP interceptor that tracks the loading state of HTTP requests.
 * It sets the loading state to true when a request is sent and sets it to false when the request is finished.
 */
export const HttpRequestInterceptor: HttpInterceptorFn = (
    req: HttpRequest<unknown>,
    next: HttpHandlerFn
): Observable<HttpEvent<unknown>> => {
    const _loading = inject(LoadingService);

    // Set the loading state to true when a request is sent
    _loading.setLoading(true, req.url);

    // Return the response from the next handler in the pipeline
    return next(req).pipe(
        // Set the loading state to false when the request is finished
        finalize(() => {
            _loading.setLoading(false, req.url);
        })
    );
}
